











import Vue from 'vue';
import LinkPreview from 'link-prevue';

export default Vue.extend({
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  components: {
    'link-preview': LinkPreview,
  },
});
